import { axiosInstance } from '@/axios'
import config from '@/config'
import { pipelineTimeout, startPipelineTimeout, successStatus } from '@/constants'

export default {
  state: {
    teamMembers: []
  },
  mutations: {
    SET_TEAM_MEMBERS (state, teamMembers) {
      state.teamMembers = teamMembers
    },
    UPDATE_PERMISSION (state, { teamMemberIndex, permission }) {
      state.teamMembers[teamMemberIndex].role = permission
    },
    REMOVE_TEAM_MEMBER (state, teamMemberIndex) {
      state.teamMembers.splice(teamMemberIndex, 1)
    }
  },
  actions: {
    getTeamMembers ({ commit }, librarySlug) {
      return axiosInstance.get(config.dataEngineUrl + 'get-users/' + librarySlug + '/emails/')
        .then((teamMembers) => {
          commit('SET_TEAM_MEMBERS', teamMembers.data)
        })
    },
    updatePermission ({ rootState, state, commit }, { teamMemberIndex, permission }) {
      const librarySlug = rootState.base.library.slug
      return axiosInstance.post('/library/' + librarySlug + '/staff/',
        {
          role: permission,
          email: state.teamMembers[teamMemberIndex].email
        })
        .then((teamMembers) => {
          commit('UPDATE_PERMISSION', { teamMemberIndex, permission })
        })
    },
    // Add a single user
    addMember ({ rootState }, user) {
      const librarySlug = rootState.base.library.slug
      return axiosInstance.post('/library/' + librarySlug + '/staff/', user)
    },
    removeTeamMember ({ rootState, state, commit }, teamMemberIndex) {
      const librarySlug = rootState.base.library.slug
      return axiosInstance.delete('/library/' + librarySlug + '/staff/', {
        data: {
          role: state.teamMembers[teamMemberIndex].role,
          email: state.teamMembers[teamMemberIndex].email
        }
      }).then((teamMembers) => {
        commit('REMOVE_TEAM_MEMBER', teamMemberIndex)
      })
    },
    addTeam ({ rootState, state, commit }, fileObj) {
      const librarySlug = rootState.base.library.slug
      this.dispatch('setLoader', true)
      return axiosInstance.post('/library/' + librarySlug + '/bulk-permissions/',
        fileObj,
        {
          headers: {
            'content-disposition': 'attachment; filename=' + fileObj.name,
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.dispatch('setLoader', false)
        // For production mode, check pipeline status after bulk-permission.
        if (!config.debug) {
          this.dispatch('setIsPipelineRunning', true)
          // Set flag for the first time.
          // In the first, check pipeline status after one minute,
          // and after, check pipeline status every 20 seconds.
          let timeout = startPipelineTimeout
          let flag = true
          const checkPipelineInterval = setInterval(
            () => {
              this.dispatch('checkPipelineStatus', { token: response.data.token, pipelineId: response.data.pipeline_id })
                .then(response => {
                  if (response.data.status === successStatus) {
                    clearInterval(checkPipelineInterval)
                    this.dispatch('getTeamMembers', librarySlug)
                    this.dispatch('setIsPipelineRunning', false)
                  }
                })
              if (flag) {
                flag = false
                timeout = pipelineTimeout
              }
            }, timeout)
        }
      })
    }
  }
}
